export default "__VITE_ASSET__DLakAKhR__"